import { call, put, takeEvery } from 'redux-saga/effects';
import Api, { API_ROOT as API, LOGIN_HELP_TEXT } from '@defi/core-api';

import {
  SET_LOGIN_TEXT,
  GET_LOGIN_TEXT,
} from '../actions/constants';

export function fetchCall() {
  const timestamp = localStorage.clientLastUpdated ? '?' + localStorage.clientLastUpdated : '';
  const path = `${LOGIN_HELP_TEXT}${timestamp}`;

  return Api.get(API.root, path)
    .then(response => Promise.resolve(response))
    .catch(function (error) {
      return Promise.reject(error);
    });
}

export function* getLoginText() {
  try {
    const response = yield call(fetchCall);

    if (response.HelpText) {
      yield put({ type: SET_LOGIN_TEXT, payload: response.HelpText });
    }

  } catch (error) {
    return false;
  }
}

export function* getLoginTextFlow() {
  yield takeEvery(GET_LOGIN_TEXT, getLoginText);
}
